import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { createTestDatabase } from '../../../utils/api'
import { getCurrentOrganizationId } from '../../../ducks/users'
import Button from '../../Shared/Button'

import styles from './InitialSetup.module.css'

export default function TestData() {
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const orgId = useSelector(getCurrentOrganizationId)

  const handleClick = useCallback(async () => {
    setLoading(true)

    try {
      await createTestDatabase(orgId)
      history.push('/')
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }, [setLoading, orgId, history])

  return (
    <div className={styles.testData}>
      <p>Don’t have a source to connect?</p>
      <Button color="grey" onClick={handleClick} loading={loading}>
        Try with Test Data
      </Button>
    </div>
  )
}
